export const API_BASE = import.meta.env.VITE_API_BASE;
export const APP_ID = import.meta.env.VITE_APP_ID;
export const BACKEND_API_HOST = import.meta.env.VITE_BACKEND_API_HOST;
// Referrer-restricted browser key, scoped to the Static Maps API alone. Its
// own key per environment (GCP `onsite-frontend`), because a referrer list is
// per key and onsite's domains are not field-app's.
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
// Shared realtime bus. Unset disables the live map's push updates; it falls
// back to its slow refetch rather than going blank.
export const CENTRIFUGO_URL = import.meta.env.VITE_CENTRIFUGO_URL;
export const ID_SERVICE_URL = import.meta.env.VITE_ID_SERVICE_URL;
export const DEPLOY_LEVEL = import.meta.env.MODE as 'development' | 'staging' | 'production';
export const AUTH_COOKIE_NAME_OF_THE_ID_SERVICE_IN_USE = import.meta.env.VITE_AUTH_COOKIE_NAME;
